<template>
  <div class="tabs">
    <ul>
      <li
        v-for="(tab, k) in tabs"
        @click="onClick(tab)"
        :key="k"
      >
        <span :class="{'active': tab.id === activeTab}">{{ tab.name }}</span>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'Tab',
  props: {
    activeTab: {
      type: String,
      default: () => '',
    },
  },
  data () {
    return {
      tabs: [
        { id: 'productInfo', name: 'ÜRÜN BİLGİLERİ' },
        { id: 'productProperty', name: 'ÜRÜN ÖZELLİKLERİ' },
        { id: 'saleInfo', name: 'SATIŞ BİLGİLERİ' },
        { id: 'cargoDelivery', name: 'KARGO & TESLİMAT BİLGİLERİ' },
      ],
    };
  },
  methods: {
    onClick (tab) {
      this.$emit('tabClick', tab);
      this.setPosition();
    },
    setPosition () {
      setTimeout(() => {
        const selected = document.querySelector('.tabs li span.active');
        const list = document.querySelector('.tabs');
        list.scrollLeft = selected.offsetLeft - ((list.clientWidth - selected.clientWidth) / 2);
      }, 250);
    },
  },
  mounted () {
    this.setPosition();
  },
  watch: {
    activeTab () {
      this.setPosition();
    },
  },
};
</script>

<style lang="scss" scoped>
  .tabs{
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #ffffff;
    overflow: hidden;
    overflow-x: auto;
    ul {
      display: flex;
      margin: 0;
      padding: 0;
      list-style: none;
      li {
        white-space: nowrap;
        flex: 1;
        span {
          font-weight: 500;
          display: block;
          padding: 10px 15px;
          color: #95A1B5;
          border-bottom:1px solid #DCDEE4;
          &.active {
            border-bottom:1px solid #f27a1a;
            color: #f27a1a;
          }
        }
      }
    }
  }
</style>
